module.exports = __webpack_public_path__ + "img/kodo_small.ab5fc3a9.png";